import assign = require('object-assign');
import { 
    FETCH_EVENTS_REQUEST, 
    FETCH_EVENTS_SUCCESS, 
    FETCH_EVENTS_FAILURE,
    FETCH_SYSTEMS_WITH_EVENTS_REQUEST, 
    FETCH_SYSTEMS_WITH_EVENTS_SUCCESS, 
    FETCH_SYSTEMS_WITH_EVENTS_FAILURE,
} from '../../constants/MAV';

import { IWidgetDataState } from '../../interfaces/states';

const initialState = {};

export function isResponsible(action) {
    switch(action.type) {
        case FETCH_EVENTS_REQUEST:
        case FETCH_EVENTS_SUCCESS:
        case FETCH_EVENTS_FAILURE:
        case FETCH_SYSTEMS_WITH_EVENTS_REQUEST:
        case FETCH_SYSTEMS_WITH_EVENTS_SUCCESS:
        case FETCH_SYSTEMS_WITH_EVENTS_FAILURE:
            return true;
        default:
            return false;
    }
}

function formatDate(event, key) {
    if (event[key]) {
        event[key] = new Date(event[key]);
    }
    return event;
}

function formatEvent(event) {
    formatDate(event, 'Timestamp');

    return event;
}

function formatEvents(events) {
    if(Array.isArray(events)) {
        events.forEach(formatEvent);
        return events;
    }

    Object.keys(events).forEach(key => {
        events[key].forEach(formatEvent);
    });

    return events;
}

export default function systems(state = initialState, action): IWidgetDataState {
    switch (action.type) {
        case FETCH_SYSTEMS_WITH_EVENTS_REQUEST:
        case FETCH_EVENTS_REQUEST: {
            return assign({}, state, {
                events: {
                    loading: true
                }
            });
        }
        case FETCH_SYSTEMS_WITH_EVENTS_SUCCESS: {
            return assign({}, state, {
                events: {
                    loading: false,
                    data: formatEvents(action.payload.events)
                }
            });
        }
        case FETCH_EVENTS_SUCCESS: {
            return assign({}, state, {
                events: {
                    loading: false,
                    data: formatEvents(action.payload)
                }
            });
        }
        case FETCH_SYSTEMS_WITH_EVENTS_FAILURE:
        case FETCH_EVENTS_FAILURE: {
            return assign({}, state, {
                events: {
                    loading: false,
                    error: action.error,
                    data: action.payload
                }
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/events.ts